import { TwoColumnLayout } from 'layouts';
import type { Media, VideoContentObject } from 'models';
import { Card, Col, Icon, Row } from 'ui';
import { DescriptionCard, DetailsCard, WatchVideo } from '../../components';
import { DownloadMedia } from './download-media';

type P = {
  fullData?: Media;
  trailerData?: Media;
  videoContentObject: VideoContentObject;
};

const VideoDetailArchivedContent = ({ fullData, trailerData, videoContentObject }: P) => (
  <TwoColumnLayout
    left={
      <Row>
        {fullData?.alts?.stream?.status === 'active' ? (
          <Col span={24}>
            <WatchVideo videoPath={fullData.alts.stream.path} />
          </Col>
        ) : null}

        {Boolean(fullData) || Boolean(trailerData) ? (
          <Col span={24}>
            <Card title={<Card.Title icon={<Icon icon="video-line" />}>Video files</Card.Title>}>
              <Row gutter={[0, 'ms']}>
                {fullData ? (
                  <Col span={12}>
                    <DownloadMedia mediaData={fullData} />
                  </Col>
                ) : null}

                {trailerData ? (
                  <Col span={12}>
                    <DownloadMedia mediaData={trailerData} />
                  </Col>
                ) : null}
              </Row>
            </Card>
          </Col>
        ) : null}

        <Col span={24}>
          <DescriptionCard videoContentObject={videoContentObject} />
        </Col>
      </Row>
    }
    right={<DetailsCard organization={videoContentObject.organization} />}
  />
);

export default VideoDetailArchivedContent;
